document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".quick-buy-btn").forEach(button => {
    if (!button.dataset.listenerAdded) {
      button.addEventListener("click", function () {
        const productForm = this.closest(".product-form");
        const selectedVariantInput = productForm.querySelector("input[name='id']:not([disabled])");
        if (!selectedVariantInput) {return;}
        const variantId = selectedVariantInput.value;
        const btnText = this.querySelector(".btn-text");
        const spinner = this.querySelector(".spinner");
        if (btnText) btnText.style.visibility = "hidden";
        if (spinner) spinner.style.display = "block";
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(response => response.json())
          .then(data => {
            setTimeout(() => {
              window.location.href = "/checkout";
            }, 500);
          })
          .catch(error => {
            if (btnText) btnText.style.visibility = "visible";
            if (spinner) spinner.style.display = "none";
          });
      });
      button.dataset.listenerAdded = "true";
    }
  });
});
